import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ItemSetupLayout = lazy(() => import('~/features/item-setup/pages/item-setup-layout'));

// Not feature-gated — available to all authenticated tenants.
// Add requireFeatureGate('item-setup') here when a backend flag is introduced.
export const Route = createFileRoute('/_authenticated/_tenant/item-setup')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ItemSetupLayout />
    </Suspense>
  ),
});
